import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

const defaultActivationDate = new Date();
const defaultExpirationDate = new Date();
defaultExpirationDate.setFullYear(defaultExpirationDate.getFullYear() + 10);
export default {
  storeNode: storeStructure.VideoContentVideos,
  title: 'Extra Components',
  attributeName:'extraComponents',
  fields: [
    {
      attributeName: 'extraComponentsEnabled',
      helpText: 'Enable or disable extra components to show in the experience.',
      label: 'Visibility',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'extraComponentsType',
      label: 'Type',
      default: '',
      type: FormInputTypes.SELECT,
      helpText: 'Choose type of extra component to show.',
      options: [
        { name: '', value: ' ' },
        { name: 'NASCAR Table Top', value: 'NASCAR' },
      ],
    },
    {
      attributeName: 'extraComponentsTitle',
      helpText: 'Title to show in the extra component.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Title',
      placeholder: 'Extra component title...',
    },
    {
      attributeName: 'extraComponentsOffset',
      helpText: 'Delay in seconds to synchronize the extra component data with the main content.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Offset',
      placeholder: 'Delay in seconds...',
    },
    {
      attributeName: 'extraComponentsGameId',
      helpText: 'External service ID to link the extra component with info referred to the main content.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Game ID',
      placeholder: 'External service ID...',
    },
  ],
};
